import { render, staticRenderFns } from "./footer-overlay.vue?vue&type=template&id=216c4470"
import script from "./footer-overlay.vue?vue&type=script&lang=js"
export * from "./footer-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports